export const NotificationPlacements = ['top', 'topLeft', 'topRight', 'bottom', 'bottomLeft', 'bottomRight'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/notification/interface.js
// module id = 3612
// module chunks = 0